import ApiNameToUpgradeProductMap from 'self-service-api/constants/ApiNameToUpgradeProductMap';
import { UPGRADE_PAGE } from 'ui-addon-upgrades/_core/common/constants/PurchaseMotionLocations';
import { APP } from '../../../constants/tracking/App';
import { SCREENS, UPGRADE_PAGES } from '../../../constants/tracking/Locations';
import PurchaseMotionButtonWrapper from '../../common/purchaseMotions/PurchaseMotionButtonWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const TrialPlanTableCTA = ({
  ctaStyles,
  currencyCode,
  productConfigurations,
  purchaseMotions,
  upgradePointApiName,
  trackingSource
}) => {
  const upgradeData = {
    apiName: upgradePointApiName,
    app: APP,
    screen: SCREENS.UPGRADE_PAGE,
    uniqueId: `${SCREENS.UPGRADE_PAGE}-${UPGRADE_PAGES.TRIAL}-${ApiNameToUpgradeProductMap[upgradePointApiName]}-feature-table`,
    upgradeProduct: ApiNameToUpgradeProductMap[upgradePointApiName]
  };
  if (!purchaseMotions || purchaseMotions.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(PurchaseMotionButtonWrapper, {
    currencyCode: currencyCode,
    level: 1,
    productConfigurations: productConfigurations,
    location: UPGRADE_PAGE,
    purchaseMotions: [purchaseMotions[0]],
    style: ctaStyles,
    trackingSource: trackingSource,
    upgradeData: upgradeData,
    use: "primary"
  });
};
export default TrialPlanTableCTA;